import React from 'react';
import Container from 'components/container';
import PublicLayout from 'components/layouts/Public';
import { BLOG_URL } from 'constants/urls';
import BlogFeed from 'containers/blog/feed';
import { blogPostFeedItems } from 'content/blog';

const BlogPage = () => {
  return (
    <PublicLayout title="Blog">
      <Container centerContent py="20px" pylg="20px">
        <BlogFeed feedItems={blogPostFeedItems} path={BLOG_URL} />
      </Container>
    </PublicLayout>
  );
};

export default BlogPage;
